import React, { useState } from 'react';
import { Button } from '@material-ui/core';
import logoWhite from 'src/images/logo.svg';
import logoCube from 'src/images/logo-CompuAccess-cube.svg';
import { Translate } from 'src/translations/i18n';
import EktacoLogo from 'src/images/EktacoIcon.svg';
import AppLanguageStorage from 'src/translations/AppLanguageStorage';
import loginPageKeys from 'src/translations/loginPageKeys';
import { useAuth } from 'react-oidc-context';
import { setAppLang } from 'src/store/actions/translationActions';
import { useDispatch } from 'react-redux';
function LoginPageContent() {
    const dispatch = useDispatch();
    const [language, setLanguage] = useState(AppLanguageStorage.languageForLogin);
    const [translation, setTranslation] = useState(loginPageKeys[AppLanguageStorage.languageForLogin]);
    const auth = useAuth();
    const updateLang = (lang) => {
        setLanguage(lang);
        setTranslation(loginPageKeys[lang]);
        AppLanguageStorage.language = lang;
        dispatch(setAppLang(lang)).catch((e) => console.error(e));
    };
    const onLoginButtonClick = () => {
        const decodedLocation = decodeURIComponent(window.location);
        const url = new URL(decodedLocation);
        const cid = url.searchParams.get('cid');
        const params = {
            data: { redirectUrl: '/' }
        };
        if (cid) {
            params.extraQueryParams = { cid };
        }
        auth.signinRedirect(params).catch((e) => console.error(e));
    };
    return (React.createElement("div", { className: "d-flex justify-content-between flex-column black-backround" },
        React.createElement("ul", { className: "cb-slideshow" },
            React.createElement("li", null,
                React.createElement("span", null, "Image 01")),
            React.createElement("li", null,
                React.createElement("span", null, "Image 02")),
            React.createElement("li", null,
                React.createElement("span", null, "Image 03")),
            React.createElement("li", null,
                React.createElement("span", null, "Image 04"))),
        React.createElement("div", { className: "img-container" },
            React.createElement("div", { className: "row-first-page" },
                React.createElement("div", { className: "d-flex justify-content-end col-12" },
                    React.createElement("ul", { className: "nav" },
                        React.createElement("li", null,
                            React.createElement("div", { className: `nav-link hover ${language === 'EST' ? 'active' : ''}`, onClick: () => updateLang('EST') }, "EE")),
                        React.createElement("li", null,
                            React.createElement("div", { className: `nav-link hover ${language === 'ENG' ? 'active' : ''}`, onClick: () => updateLang('ENG') }, "EN")),
                        React.createElement("li", null,
                            React.createElement("div", { className: `nav-link hover ${language === 'RUS' ? 'active' : ''}`, onClick: () => updateLang('RUS') }, "RU")))))),
        React.createElement("div", { className: "img-container" },
            React.createElement("div", { className: "justify-content-center d-flex row-first-page" },
                React.createElement("div", { className: "col-12 d-none justify-content-sm-center d-sm-flex fp-position" },
                    React.createElement("img", { src: logoWhite, alt: "CompuAccess", className: "logoWitheText" })),
                React.createElement("div", { className: "col-12 d-sm-none d-flex justify-content-center" },
                    React.createElement("img", { src: logoCube, alt: "CompuAccess", className: "logoCube" })),
                React.createElement("div", { className: "col-12 mt-4" },
                    React.createElement("h1", { className: "text-center text-white display-4" }, translation.mainSlogan)),
                React.createElement("div", { style: { marginTop: 35 } },
                    React.createElement(Button, { className: "login-button", variant: "contained", onClick: onLoginButtonClick },
                        React.createElement(Translate, { value: translation.buttonLabel }))))),
        React.createElement("div", { className: "img-container" },
            React.createElement("div", { className: "row-first-page" },
                React.createElement("div", { className: "col-12 d-sm-none d-flex justify-content-center" }),
                React.createElement("a", { href: "https://www.ektaco.ee/product/compuaccess/", target: "_blank", rel: "noopener noreferrer", className: "ektaco-link" },
                    React.createElement("div", { className: "ektaco-link-icon-container" },
                        React.createElement("img", { src: EktacoLogo, alt: "CompuAccess", className: "ektaco-link-icon" })),
                    React.createElement("span", { className: "ektaco-link-text" }, "www.ektaco.ee"))))));
}
export default LoginPageContent;
